const routes = {
    path: 'solucoes',
    name: 'Solucoes',
    component: () => import('./Solucao.vue'),
    children: [
        {
            path: 'inserir',
            name: 'Solucao_Inserir',
            component: () => import('./SolucaoForm.vue'),
            meta: {
                rules: ['SOL-001'],
            }
        },
        {
            path: ':id/atualizar',
            name: 'Solucao_Atualizar',
            component: () => import('./SolucaoForm.vue'),
            meta: {
                rules: ['SOL-001'],
            }
        },
        {
            path: ':id/visualizar',
            name: 'Solucao_Visualizar',
            component: () => import('./SolucaoVisualizar.vue'),
            meta: {
                rules: ['SOL-001', 'SOL-000'],
            }
        },
        {
            path: ':id/imagens',
            name: 'Solucao_Imagens',
            component: () => import('./SolucaoImagens.vue'),
            meta: {
                rules: ['SOL-001'],
            }
        },
    ],
    meta: {
        rules: ['SOL-001'],
    }
};

export default routes;
